import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import AdminLayout from '../../layouts/AdminLayout';
import NotificationFormModal from './NotificationFormModal';

export default function NotificationFormPage() {
  const history = useHistory();
  const location = useLocation();
  const reuseData = location.state?.reuse || null;

  const handleClose = () => {
    history.push('/notifications');
  };

  const handleSuccess = () => {
    history.push('/notifications');
  };

  const handleOpenWebNotification = (data) => {
    history.push({
      pathname: '/web-notifications/create',
      state: { prefill: data },
    });
  };

  return (
    <AdminLayout title="Send Notification">
      <NotificationFormModal
        open={true}
        initialData={reuseData}
        onClose={handleClose}
        onSuccess={handleSuccess}
        onOpenWebNotification={handleOpenWebNotification}
      />
    </AdminLayout>
  );
}